import { file, prop, required } from '@rxweb/reactive-form-validators';

export class MediaModel {
	@file({ maxFiles: 1 })
	resource?: any;

	@prop({ name: 'resource_url' })
	resourceUrl: string;

	@required()
	name: string;

	@required()
	description: string;


	@prop({name: 'categories'})
    categories: any;
	@prop({name: 'client_id'})
    client_id: any;
	@prop({name: 'media_client_id'})
    media_client_id: any;
	@prop({name: 'use_reproducciones_contratadas'})
    use_reproducciones_contratadas: boolean = true;
	@prop({name: 'reproducciones_contratadas'})
    reproducciones_contratadas: any;
	@prop()
	fecha: Date;

	@prop()
	vigencia: Date;

}
